import ViewBase from "../../../../framework/core/mvvm/view_base";

const {ccclass, property} = cc._decorator;

@ccclass
export default class SeekPlayer extends ViewBase {
    @property(cc.Float)
    interval:number = 0;

    @property([cc.Node])
    points:cc.Node[] = [];

    @property(cc.Label)
    playerLabel:cc.Label = null;

    @property(cc.Node)
    root:cc.Node = null;

    onEnable(){
        this.root.active = false;
        this.playerLabel.string = '';
        this.root.stopAllActions();
        this.resetPoints();
        this.eventBind('update_seek_player',this.updateLab);
    }

    private updateLab(cur:number,total:number){
        cur = cur || 0;
        total = total || 0;
        let isShow = cur < total;
        this.root.active = isShow;
        this.root.stopAllActions();
        if (!isShow) {
            return;
        }
        this.updateCnt(cur,total);
        this.doAction();
    }

    private updateCnt(cur:number,total:number){
        this.playerLabel.string = '({0}&{1})'.format(cur,total);
    }

    private resetPoints(){
        for (let point of this.points) {
            point.active = false;
        }
    }

    doAction(){
        let index = 0;
        this.resetPoints();
        this.points[index++].active = true;
        let delayAction = cc.delayTime(this.interval);
        let sequence = cc.sequence(delayAction , cc.callFunc(()=>{
            if (index >= this.points.length) {
                index = 0;
                this.resetPoints();   
            }else{
                let point = this.points[index];
                if (point) {
                    point.active = true;
                }
                index++;
            }
        }));
        let action = cc.repeatForever(sequence);
        this.root.runAction(action);
    }

    onDisable(){
        this.eventUnBind('update_seek_player',this.updateLab);
    }

    onDestroy(){
        this.eventUnBind('update_seek_player',this.updateLab);
    }

}
